import {
  BrowserRouter,
  Routes ,
  Route,
} from "react-router-dom";

// Pages
import Home from "./pages/Home.jsx"
import Letter from "./pages/Letter.jsx"
import _404Page from "./pages/404.jsx";
import CreditTag from "./components/CreditTag.jsx";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes >
          <Route path="/Letter/*" element={<Letter/>}/>
          <Route path="/" element={<Home/>}/>
          <Route path="*" element={<_404Page/>}/>
        </Routes >
      </BrowserRouter>
      <CreditTag/>
    </div>
  );
}

export default App;
